import { render, staticRenderFns } from "./BindsWarningIcon.vue?vue&type=template&id=1037da48&"
import script from "./BindsWarningIcon.vue?vue&type=script&lang=js&"
export * from "./BindsWarningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports